// export const planNamesId = (licenses, planId) => {
//   if (licenses?.licenses?.length > 0) {
//     const plan = licenses?.licenses.find(
//       (license) => license.planId === planId
//     );
//     if (plan) {
//       return plan.licenseType;
//     }
//   }
// };

export const planNamesId = (licenses, planId) => {
  if (!licenses || !planId) return;

  const sources = [
    licenses?.plans?.licenses,
    licenses?.features?.licenses,
    licenses?.plans?.dedicatedPlans,
  ];

  for (const source of sources) {
    const plan = source?.find((license) => license.planId === planId);
    if (plan) return plan.licenseType;
  }
};
